export const DividerSize = {
    line: 'divide-y',
    xxSmall: 'divide-y h-1',
    xSmall: 'divide-y h-2',
    small: 'divide-y h-5',
    base: 'divide-y  h-10',
    medium: 'divide-y h-14',
    large: 'divide-y  h-20',
    xLarge: 'divide-y  h-28',
}

export const SetDotted = 'border-b border-dotted'

export const SetLine = `border-b border-solid border-mediumGrey`
